import { useTranslations } from 'next-intl';
import useI18n from './useI18n';
import {
  ISocialMedia,
  socialsMedia,
  socialsMedia_DEFAULT,
} from '@monofront/business/constants';
import { OrganizationJsonLdProps } from 'next-seo';

const infos: {
  fr: Partial<OrganizationJsonLdProps>;
  de: Partial<OrganizationJsonLdProps>;
} = {
  fr: {
    '@type': 'OnlineStore',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '10 rue des Frères Lumière',
      addressLocality: 'Mitry-Mory',
      addressCountry: 'FR',
      addressRegion: 'Ile-de-France',
      postalCode: '77290',
    },
    contactPoint: [
      {
        contactType: 'Customer Service',
        email: 'contact@lafourche.fr',
      },
    ],
    email: 'contact@lafourche.fr',
    logo: 'https://cms-cdn.lafourche.fr/94b37e2b-1e00-46ec-805a-557e2eff65b7_Logo+La+Fourche.jpg',
    hasMerchantReturnPolicy: {
      '@type': 'MerchantReturnPolicy',
      applicableCountry: ['FR', 'BE', 'LU'],
      returnPolicyCountry: 'FR',
      returnPolicyCategory:
        'https://schema.org/MerchantReturnFiniteReturnWindow',
      merchantReturnDays: 14,
      returnMethod: 'https://schema.org/ReturnByMail',
      returnFees: 'https://schema.org/FreeReturn',
      refundType: 'https://schema.org/FullRefund',
    },
    vatID: 'FR43839765062',
  },
  de: {
    '@type': 'OnlineStore',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Urbanstraße 71',
      addressLocality: 'Berlin',
      addressCountry: 'DE',
      addressRegion: 'Berlin-Brandebourg',
      postalCode: '10967',
    },
    contactPoint: [
      {
        contactType: 'Customer Service',
        email: 'community-support@ackerherz.de',
      },
    ],
    email: 'community-support@ackerherz.de',
    logo: 'https://www.ackerherz.de/icons/brand_logos/de.svg',
    hasMerchantReturnPolicy: {
      '@type': 'MerchantReturnPolicy',
      applicableCountry: ['DE'],
      returnPolicyCountry: 'DE',
      returnPolicyCategory:
        'https://schema.org/MerchantReturnFiniteReturnWindow',
      merchantReturnDays: 14,
      returnMethod: 'https://schema.org/ReturnByMail',
      returnFees: 'https://schema.org/FreeReturn',
      refundType: 'https://schema.org/FullRefund',
    },
    vatID: 'DE351237313',
  },
};

const useLocalizedOrganizationInfos = (): OrganizationJsonLdProps => {
  const { locale, domain } = useI18n();
  const tSEODEFAULT = useTranslations('SEO.DEFAULT');
  const tGlobal = useTranslations('Global');
  const socialsMediaLinks = Object.values<ISocialMedia>(
    socialsMedia[locale] || socialsMedia_DEFAULT,
  ).map(({ homepage }) => homepage);

  return {
    ...infos[locale],
    description: tSEODEFAULT('description'),
    name: tGlobal('companyName'),
    sameAs: socialsMediaLinks,
    url: `https://${domain}/`,
  };
};

export default useLocalizedOrganizationInfos;
